module.exports = __webpack_public_path__ + "as.e922b2df545875b20b8b.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/as.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/as.svg
// module chunks = styles